export default "/_next/static/videos/audio-video-mobile-a9f41b9fec767275fb9f194f601230bd.mp4";